import styled from "styled-components";
import "../i18n";
import { useState, useEffect } from "react";
import "react-circular-progressbar/dist/styles.css";
import { changeLanguage } from "i18next";
import { useSearchParams } from "react-router-dom";
import logo from "../assets/img/eyLogo.jpg";
import { I18nString } from "../types/I18nString";
import { COLOR, VerticalGridContainer } from "./styles";
import TournamentBracket from "./TournamentBracket";

const Microsite = () => {
  let [searchParams] = useSearchParams();
  const [locale, setLocale] = useState<keyof I18nString>("en");

  useEffect(() => {
    const lang = searchParams.get("locale") || navigator.language || "en";
    changeLanguage(lang.substring(0, 2));
    setLocale(lang.substring(0, 2) as keyof I18nString);
  }, [searchParams]);

  const ownTeamIds = new Set(
    [
      ...(searchParams.get("teamIds")?.split(",") || []),
      searchParams.get("teamId") || "",
    ]
      .map((id) => id.trim())
      .filter(Boolean)
  );

  return (
    <Container>
      <BackgroundHeader id={"nav"} />
      <VerticalGridContainer style={{ marginTop: -35 }}>
        <TournamentBracket locale={locale} ownTeamIds={ownTeamIds} />
      </VerticalGridContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
  min-height: 100vh;
`;

const BackgroundHeader = styled.div`
  background-color: ${COLOR};
  min-height: 140px;
  width: 100%;
  display: flex;
  background-image: url(${logo});
  background-size: 90px;
  background-repeat: no-repeat;
  background-position-y: 20px;
  background-position-x: 8px;
`;

export default Microsite;
